export default "__VITE_ASSET__ClMxsnb7__"